import React from "react";
import { Truck, Clock, Globe, PackageCheck, MapPin } from "lucide-react";
import PageShell, { Section } from "../components/PageShell";

export default function Envios() {
  return (
    <PageShell
      title="Política de Envio"
      subtitle="Tudo o que precisas de saber sobre prazos, portes e acompanhamento da tua encomenda."
      breadcrumb="Envios & Entregas"
    >
      {/* Quick cards */}
      <div className="grid sm:grid-cols-3 gap-4 not-prose">
        {[
          { icon: Truck, title: "Envio grátis", desc: "Em compras acima de 35€" },
          { icon: Clock, title: "2 a 5 dias úteis", desc: "Entrega em Portugal Continental" },
          { icon: Globe, title: "Envio internacional", desc: "Para toda a Europa" },
        ].map((c) => (
          <div key={c.title} className="border border-border rounded-lg p-5 bg-card">
            <c.icon className="h-6 w-6 text-primary mb-3" />
            <p className="font-medium text-foreground">{c.title}</p>
            <p className="text-sm text-muted-foreground mt-1">{c.desc}</p>
          </div>
        ))}
      </div>

      <Section title="Prazos de processamento">
        <p>
          Todas as encomendas são processadas no prazo de <strong>1 a 2 dias úteis</strong> após
          a confirmação do pagamento. As encomendas efetuadas ao fim de semana ou em feriados
          são processadas no dia útil seguinte.
        </p>
        <p>
          Assim que a tua encomenda for expedida, receberás um email de confirmação com o
          número de rastreio para poderes acompanhar a entrega em tempo real.
        </p>
      </Section>

      <Section title="Prazos e custos de entrega">
        <p>Os prazos indicados começam a contar após o processamento da encomenda:</p>
        <div className="overflow-x-auto not-prose">
          <table className="w-full text-sm border border-border rounded-lg overflow-hidden">
            <thead className="bg-secondary text-foreground">
              <tr>
                <th className="text-left p-3 font-medium">Destino</th>
                <th className="text-left p-3 font-medium">Prazo estimado</th>
                <th className="text-left p-3 font-medium">Custo</th>
              </tr>
            </thead>
            <tbody className="text-muted-foreground">
              {[
                ["Portugal Continental", "2 – 5 dias úteis", "4,99€ (grátis acima de 35€)"],
                ["Ilhas (Madeira e Açores)", "5 – 8 dias úteis", "7,99€"],
                ["Espanha", "4 – 7 dias úteis", "6,99€"],
                ["Resto da Europa", "6 – 10 dias úteis", "9,99€"],
              ].map((row, i) => (
                <tr key={i} className="border-t border-border">
                  {row.map((cell, j) => (
                    <td key={j} className="p-3">{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-sm">
          Nota: os prazos são estimativas e podem sofrer alterações em períodos de grande
          volume (campanhas, saldos, época festiva) ou por motivos alheios à RADIX
          (condições meteorológicas, alfândega, transportadora).
        </p>
      </Section>

      <Section title="Acompanhamento da encomenda">
        <p>
          Após a expedição, poderás rastrear a tua encomenda através do link enviado por email.
          Se após 48 horas o rastreio ainda não apresentar movimentos, contacta-nos para
          <strong> apoio@radix.pt</strong> e nós tratamos de tudo.
        </p>
      </Section>

      <Section title="Entregas e ausências">
        <p>
          A transportadora fará até <strong>2 tentativas de entrega</strong>. Caso não seja
          possível entregar, a encomenda ficará disponível para levantamento num ponto de
          recolha durante alguns dias. Recomendamos que indiques uma morada onde te seja
          fácil receber a encomenda (por exemplo, o local de trabalho).
        </p>
      </Section>

      <Section title="Encomendas danificadas ou extraviadas">
        <div className="flex items-start gap-3 not-prose bg-secondary/50 border border-border rounded-lg p-4">
          <PackageCheck className="h-5 w-5 text-primary mt-0.5 shrink-0" />
          <p className="text-sm text-muted-foreground">
            Se a tua encomenda chegar danificada ou não chegar dentro do prazo previsto,
            contacta-nos no prazo de 7 dias. Vamos resolver a situação com o reenvio do
            produto ou o reembolso total, sem custos para ti.
          </p>
        </div>
      </Section>

      <Section title="Precisas de ajuda?">
        <p className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-primary" />
          A nossa equipa de apoio responde em 24h úteis: <strong>apoio@radix.pt</strong>
        </p>
      </Section>
    </PageShell>
  );
}
